import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { useNavigate } from "react-router";
import { FaArrowCircleRight } from "react-icons/fa";
import performRequest from "../../../APIs/request";
import { departmentsInfo } from "../../../Schema Info/departmentsInfo";
import Pagination from "../../../Components/layouts/pagination";
import GetRandomUserImage from "./get_random_user_image";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../../Redux/Pagination & Filters/filtersReducer";

const GetTestDetails = () => {
  const store = useSelector((store) => store.filters);
  const [department, setDepartments] = useState(departmentsInfo);
  const [data, setData] = new useState([]);
  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [filters, setFilters] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    let ft = [];
    if (filters && filters.length > 0 && filters[0]?.value == "all") {
      ft = [];
    } else {
      ft = filters.map((f) => f.value);
    }
    performRequest(
      "POST",
      `/test/alltestsbydepartment?page=${store.currentPage}`,
      ft
    )
      .then((res) => {
        setData(res.data.data);
        setTotalData(res.data.totalData);
        setTotalPages(Math.ceil(res.data.totalData / 20));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [refresh, store.currentPage, filters]);
  const takeTest = (id) => {
    navigate(`/get-skill-badges/${id}`);
  };

  useEffect(() => {
    performRequest("GET", "/test/getdepartmentcount")
      .then((res) => {
        setDepartments(res.data);
        document.getElementById("all-departments").click();
      })
      .catch((err) => console.error(err));
  }, []);
  const removeFilter = (ele) => {
    ele.ele.checked = false;
    let arr = filters.filter((f) => f.value !== ele.value);
    setFilters(arr);
    setShowPage(1);
    setPage(1);
  };

  const handelCheckboxChange = (e) => {
    if (e.target.checked) {
      let arr = filters?.filter((ele) => {
        if (ele.value == "all") {
          ele.ele.checked = false;
          return false;
        } else {
          return ele.value !== e.target.value;
        }
      });
      let obj = {
        key: e.target.name,
        value: e.target.value,
        ele: e.target,
      };
      arr.unshift(obj);
      setFilters(arr);
      setShowPage(1);
      setPage(1);
    } else {
      let arr = filters?.filter((ele) => ele.value !== e.target.value);
      setFilters(arr);
      setShowPage(1);
      setPage(1);
    }
  };
  const handelApplyAllDepartments = (e) => {
    if (e.target.checked) {
      let arr = [];
      let obj = {
        key: e.target.name,
        value: e.target.value,
        ele: e.target,
      };
      for (let i = 0; i < filters.length; i++) {
        filters[i].ele.checked = false;
      }
      arr.unshift(obj);
      setFilters(arr);
      setShowPage(1);
      setPage(1);
    } else {
      let arr = filters?.filter((ele) => ele.value !== e.target.value);
      setFilters(arr);
      setShowPage(1);
      setPage(1);
    }
  };
  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };
  return (
    <div className="Page">
      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xxl">
            <div className="row row-cards">
              <div className="col-12">
                <div className="section-header">
                  <h2 className="section-title section-title-lg m-0 p-0">
                    GET YOURSELF BADGED.
                  </h2>
                  <p className="section-description mb-4 p-0">
                    Get yourself 'Skill Verified'!
                  </p>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-4">
                    <div className="card">
                      <h3 className="m-2 p-2">Select Departments</h3>
                      <div>
                        {filters?.map((ele, index) => {
                          return (
                            <span
                              className="m-1 tag"
                              key={index}
                              onClick={() => removeFilter(ele)}
                            >
                              {ele.value}
                              <a href="#" className="btn-close"></a>
                            </span>
                          );
                        })}
                      </div>
                      <div className="list-group list-group-flush">
                        <span
                          key={1234}
                          className="list-group-item list-group-item-action py-2 px-2"
                        >
                          <input
                            id="all-departments"
                            className="form-check-input me-2 cursor-pointer"
                            type="checkbox"
                            onChange={(e) => handelApplyAllDepartments(e)}
                            name="Department"
                            value={"all"}
                          />
                          <span className="text-start fs-5">
                            {"Select All"}
                          </span>
                          <span className="badge bg-blue-lt ms-2">
                            {233 || 0}
                          </span>
                        </span>
                        {department?.map((department, i) => {
                          return (
                            <>
                              {department.count !== 0 && (
                                <span
                                  key={i}
                                  className="list-group-item list-group-item-action py-2 px-2"
                                >
                                  <input
                                    className="form-check-input me-2 cursor-pointer"
                                    type="checkbox"
                                    onChange={(e) => handelCheckboxChange(e)}
                                    name="Department"
                                    value={department?.dep}
                                  />
                                  <span className="text-start fs-5">
                                    {department.dep.toUpperCase()}
                                  </span>
                                  <span className="badge bg-blue-lt ms-2">
                                    {department.count || 0}
                                  </span>
                                </span>
                              )}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-9 col-md-8">
                    <div className="card">
                      <div className="m-3 p-0">
                        <h3 className="m-0 p-0">Most Enrolled Tests</h3>
                        <p className="m-0 p-0">
                          Total tests found: {totalData}
                        </p>
                      </div>
                      <hr className="m-0 p-0" />
                      <div className="card-body">
                        <div className="row row-deck row-cards m-1">
                          {data.map((test, i) => {
                            return (
                              <div
                                className="col-lg-3 col-md-6 col-sm-12"
                                key={i}
                              >
                                <div className="card card-link card-link-pop bg-secondary-lt">
                                  <div className="card mx-4 mt-4 p-3">
                                    <img src={test?.icon} />
                                  </div>

                                  <div className="card-body m-0 p-2">
                                    <h3
                                      style={{
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 1,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      className="card-title m-0 p-0 fs-3"
                                    >
                                      {test.name}
                                    </h3>

                                    <p>
                                      <span className="badge badge-md bg-lime-lt m-0 p-0">
                                        {(test?.level || "N/A").toUpperCase()}{" "}
                                        LEVEL
                                      </span>
                                    </p>
                                    <hr className="my-2 p-0" />

                                    <div className="col-auto">
                                      <div className="avatar-list avatar-list-stacked ">
                                        {test.enrolledusers &&
                                          test.enrolledusers.length > 0 && (
                                            <GetRandomUserImage
                                              max={test.enrolledusers.length}
                                              userData={test.enrolledusers}
                                              classes={
                                                "avatar avatar-xs rounded"
                                              }
                                            />
                                          )}
                                      </div>
                                      <span>
                                        +
                                        {test.enrolledUsers +
                                          test.enrolledusers.length}{" "}
                                        Enrolled
                                      </span>
                                    </div>
                                    <div className="col-auto ms-auto">
                                      <button
                                        onClick={() => takeTest(test?.id)}
                                        className="btn btn-primary w-100"
                                      >
                                        <FaArrowCircleRight
                                          fontSize={"1em"}
                                          className="me-2"
                                        />{" "}
                                        Take Test
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div>
                        <Pagination
                          page={page}
                          setPage={setPage}
                          totalPages={totalPages}
                          pageDatalength={data?.length}
                          showPage={showPage}
                          setShowPage={setShowPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default GetTestDetails;
